<template>
    <div class="hidden lg:block pt-2 border-t-0">
        <div class="font-main font-bold text-a-brown-502314 text-base lg:text-18 mb-3 text-center">
            <div v-if="priceBeforeDiscount > totalPrice">
                {{ lbl.productDetail.price }} <span class="line-through text-a-brown-9f8273">{{ priceBeforeDiscount }}</span> {{ totalPrice }} {{ lbl.productDetail.priceUnit }}
            </div>
            <div v-else>
                {{ priceLabel }}
            </div>
        </div>
        <div class="max-w-xs mx-auto">
            <RedButton v-if="enable" customClass="py-2.5 lg:py-3 px-2 w-full lg:text-18" @click="clickAdd()">
                {{ btnAddLabel }}
            </RedButton>
            <DisableBtn v-else>
                {{ btnAddLabel }}
            </DisableBtn>
        </div>
    </div>
    <div class="lg:hidden fixed bottom-0 left-0 w-full custom-shadow bg-a-brown-f5ebdc pb-3 pt-2">
        <div class="font-main text-a-brown-502314 text-16 mb-3 text-center">
            <div v-if="priceBeforeDiscount && subscriptionSelected">
                {{ lbl.productDetail.price }} <span class="line-through text-a-brown-9f8273">{{ priceBeforeDiscount }}</span> {{ totalPrice }} {{ lbl.productDetail.priceUnit }}
            </div>
            <div v-else>
                {{ priceLabel }}
            </div>
        </div>
        <div class="max-w-xs mx-auto">
            <RedButton v-if="enable" customClass="py-2.5  px-2 w-full" @click="clickAdd()">
                {{ btnAddLabel }}
            </RedButton>
            <DisableBtn v-else>
                {{ btnAddLabel }}
            </DisableBtn>
        </div>
    </div>
</template>
<script>
// composable
import { computed, inject } from 'vue'
import useAddToBagButton from "../composable/useAddToBagButton"

// helper
import Utility from '@/helper/Utility'

// component
import RedButton from '@/components/Button/RedButton.vue'
import DisableBtn from '@/components/Button/DisableBtn.vue';

export default {
    name: 'ButtonAddToBag',
    props: {
        enable: { type: Boolean, default: true },
        subscriptionItem: { type: Array }
    },
    components: {
        RedButton,
        DisableBtn
    },
    emits: ["onClickAdd"],
    setup: function (props, context) {
        const { lbl } = inject("LocaleStore")
        const campaign = inject("Campaign")
        const btnAddLabel = lbl.value.productDetail.btnAddToBag
        const priceLblRaw = lbl.value.productDetail.priceLabel

        const totalPrice = inject("PriceState")
        const priceBeforeDiscount = inject("PriceBeforeDiscountState")
        const subscriptionSelected = inject("SubscriptionSelected")
        const priceLabel = computed(() => {
            return Utility.stringFormat(priceLblRaw, Utility.formatNum(totalPrice.value))
        })
        const btnState = useAddToBagButton(campaign)

        const clickAdd = function () {
            if (btnState.isAllow) {
                context.emit("onClickAdd")
            } else {
                // show something
            }

        }

        console.log("ButtonAddToBag", subscriptionSelected)

        return {
            btnAddLabel,
            priceLabel,
            btnState,
            clickAdd,
            totalPrice,
            campaign,
            lbl,
            priceBeforeDiscount,
            subscriptionSelected,
        }
    }
}
</script>

<style scoped lang="scss">
.custom-shadow {
    box-shadow: 0 -1px 5px 0 rgba(0, 0, 0, 0.16);
}
</style>
